import { useState } from 'react';

import Popup from '@/components/Popup/PopUp/PopUp';
import Button from '@/components/shared/Button/Button';
import { Text } from '@/components/shared/Text/Text';
import { Tariff } from '@/lib/types/tariff';
import { Market } from '@addmile/backend-client';

interface ChangeLtvPopupProps {
  isOpen: boolean;
  selectedMarket: Market;
  selectedTariff: Tariff;
  closePopup: () => void;
  confirmText?: string;
  handleConfirm: (newLtv: string) => void;
}

export const ChangeLtvPopup = ({
  isOpen,
  selectedMarket,
  selectedTariff,
  closePopup,
  confirmText = 'Confirm',
  handleConfirm,
}: ChangeLtvPopupProps) => {
  const [ltv, setLtv] = useState<string | null>(
    selectedTariff.ltvs.find((ltv) => ltv.market === selectedMarket)?.amount || '',
  );

  return (
    <Popup isOpen={isOpen} handleClose={closePopup}>
      <div>
        <Text.Bigger className="mb-4 text-center" weight="medium">
          {'Change LTV'} <span className="font-bold">{selectedMarket}</span> {'for tariff'}
          {'\n'}
          <span className="font-bold">{selectedTariff.name}</span>
        </Text.Bigger>

        <input
          type="number"
          value={ltv || ''}
          onChange={(e) => setLtv(e.target.value)}
          onBlur={() => setLtv((prev) => (prev ? parseFloat(prev).toFixed(2) : ''))}
          className="w-full mt-2 p-2 border border-gray-300 rounded-md"
        />

        <div className="flex justify-center items-center gap-2 mt-4">
          <Button
            label={confirmText}
            size="m"
            className="!w-44"
            onClick={() => handleConfirm(String(ltv))}
          />
          <Button
            prefixIcon={<img alt={'close'} src={'/icons/close_outline.svg'} />}
            label="Cancel"
            variant="secondary"
            onClick={closePopup}
            className="!w-28"
            size="m"
          />
        </div>
      </div>
    </Popup>
  );
};
